<template>
    <checkout-step>
        <template slot="title">
            {{ __('Summary') }}
        </template>

        <portal-target
            v-if="portalAvailable"
            name="checkout-summary-before"
        />

        <div class="cart-content">
            <cart-item
                v-for="item in items"
                :key="item.id.identifier"
                :readonly="true"
                :item="item"
            />

            <div class="card cart-summary">
                <div class="card-body">
                    <div class="cart-total-net">
                        <span class="label">{{ __('Total net price:') }}</span>
                        <span class="price">{{ formatNegativePrice(price.net) | currency }}</span>
                    </div>

                    <div class="cart-total-vat">
                        <span class="label">{{ __('Total vat value:') }}</span>
                        <span class="price">{{ formatNegativePrice(price.vatValue) | currency }}</span>
                    </div>

                    <div class="cart-total-gross">
                        <span class="label">{{ __('Total gross price:') }}</span>
                        <span class="price">{{ formatNegativePrice(price.gross) | currency }}</span>
                    </div>

                    <div
                        v-if="shippable && data"
                        class="cart-transport-cost"
                    >
                        <span class="label">{{ __('Shipping cost') }}:</span>
                        <span class="price">{{ formatNegativePrice(shippingCost) | currency }}</span>
                    </div>

                    <div
                        v-if="data && data.paymentFee > 0"
                        class="cart-payment-cost"
                    >
                        <span class="label">{{ __('Payment cost') }}:</span>
                        <span class="price">{{ formatNegativePrice(paymentFee) | currency }}</span>
                    </div>

                    <div
                        v-if="data"
                        class="cart-amount-to-be-paid"
                    >
                        <span class="label">{{ __('Amount to be paid') }}:</span>
                        <span class="price">
                            {{ formatNegativePrice(price.gross + data.shippingCost + data.paymentFee) | currency }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="container px-0">
            <portal-target
                v-if="portalAvailable"
                name="summary-step-above-user-data"
            />
        </div>
        <div
            v-if="data !== null"
            class="form-group user-data"
        >
            <h2>
                {{ __('Basic data') }}
            </h2>

            {{ data.userData.name }}<br>
            {{ data.userData.email }}<br>
            {{ phoneNumber }} <br>
        </div>

        <div
            v-if="shippable && data !== null"
            class="form-group shipping-mode"
        >
            <h2>
                {{ __('Shipping mode') }}
            </h2>
            {{ data.shippingMode.name }}<br>
        </div>

        <div
            v-if="data && data.paymentMode"
            class="form-group payment-mode"
        >
            <h2>
                {{ __('Payment mode') }}
            </h2>

            {{ data.paymentMode.name }}<br>
        </div>

        <div
            v-if="data !== null"
            class="form-group billing-data"
        >
            <h2>
                {{ __('Billing data') }}
            </h2>

            {{ data.userData.billing_name }}<br>
            {{ data.userData.billing_zip }}<br>
            {{ data.userData.billing_city }}<br>
            {{ data.userData.billing_address }} {{ data.userData.billing_house_number }}<br>
            <span v-if="data.userData.vat_number">
                {{ __('Vat number') }}: {{ data.userData.vat_number }}
            </span>
        </div>

        <div
            v-if="shippable && data !== null"
            class="form-group shipping-data"
        >
            <h2>
                {{ __('Shipping data') }}
            </h2>

            <div v-if="selectedShippingModeHasPickupPoints">
                {{ selectedPickupPointData.name }}<br>
                {{ selectedPickupPointData.zip }}<br>
                {{ selectedPickupPointData.city }}<br>
                {{ selectedPickupPointData.address }}<br>
            </div>
            <div v-else>
                {{ data.userData.shipping_name || data.userData.billing_name }}<br>
                {{ data.userData.shipping_zip || data.userData.billing_zip }}<br>
                {{ data.userData.shipping_city || data.userData.billing_city }}<br>
                {{ data.userData.shipping_address || data.userData.billing_address }} {{ data.userData.shipping_house_number || data.userData.billing_house_number }}<br>
            </div>
        </div>

        <portal-target
            v-if="portalAvailable"
            name="checkout-summary-after"
        />

        <form
            ref="form"
            method="post"
            :action="route('shop.checkout.store')"
        >
            <div class="form-group comment">
                <label for="comment">{{ __('Comment') }}</label>
                <textarea
                    id="comment"
                    name="comment"
                    class="form-control"
                />
            </div>

            <div class="container p-0 text-right">
                <portal-target
                    v-if="portalAvailable"
                    class="d-inline text-right"
                    name="summary-step-below-comment"
                />
            </div>
            <div class="container p-0 text-right mb-2">
                <span>
                    <input
                        id="acceptTerms"
                        v-model="acceptTerms"
                        type="checkbox"
                        name="acceptTerms"
                    >
                </span>
                <portal-target
                    v-if="portalAvailable"
                    class="d-inline text-right"
                    name="summary-step-accept-terms"
                />
            </div>
            <div
                v-if="!acceptTerms && triedToSubmit"
                class="container p-0 text-right"
            >
                <span
                    class="alert-danger"
                    style="padding: 6px;border-radius: 6px;"
                >
                    {{ __('You must accept the Terms and Conditions!') }}
                </span>
            </div>

            <input
                type="hidden"
                name="_token"
                :value="csrfToken()"
            >
        </form>
        <template
            slot="navigation"
            slot-scope="{ prev }"
        >
            <button
                type="button"
                class="btn btn-danger cart-btn-back"
                @click="prev()"
            >
                {{ __('Back') }}
            </button>
            <button
                class="btn btn-primary float-right cart-btn-next cart-btn-submit"
                :disabled="submitIsDisabled"
                @click="submitForm"
            >
                {{ __('Submit') }}
            </button>
        </template>
    </checkout-step>
</template>

<script>
import summaryStepBase from '../../../mixins/checkout/summaryStepBase'

export default {
    mixins: [summaryStepBase]
}
</script>
